import React from 'react';
import { DataProvider, useDataContext } from './response-context';
import AppVocationOneReport from '../AppVocationOne';
import AppVocationJuniorReport from '../AppVocationJunior';
import AppVocationStartReport from '../AppVocationStart';

const SwitchPage = props => {
  const { response, isLoading } = useDataContext();

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (!response && !isLoading) {
    console.log('not found, redirect');
    return <div>Not found</div>;
  }
  // console.log({ response });
  const { campaign, data } = response;
  if (campaign.SKU === 'VOCATION_ONE') {
    return (
      <AppVocationOneReport
        campaign={campaign}
        response={response}
        data={data}
      />
    );
  }

  if (campaign.SKU === 'VOCATION_JUNIOR') {
    return (
      <AppVocationJuniorReport
        campaign={campaign}
        response={response}
        data={data}
      />
    );
  }

  if (campaign.SKU === 'VOCATION_START') {
    return (
      <AppVocationStartReport
        campaign={campaign}
        response={response}
        data={data}
      />
    );
  }

  return (
    <div>
      <div>{response.id}</div>
    </div>
  );
};

const DataWrapper = props => {
  // console.log({ props });
  return (
    <DataProvider id={props.match.params.id}>
      <SwitchPage {...props} />
    </DataProvider>
  );
};
export default DataWrapper;
